import { Component, Output, EventEmitter } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { UserService } from "../../../services/user.service"
import { EduComponent } from "../../../utils/eduComponent"
import { LeaveRosterModalComponent } from "../../modals/leave-roster-modal/leave-roster-modal.component"

@Component({
    selector: "app-student-classes",
    templateUrl: "./student-classes.component.html",
    styleUrls: ["./student-classes.component.less"],
})
export class StudentClassesComponent extends EduComponent {
    public classes = []
    public rosterCode = ""
    @Output() joinCodeEntered = new EventEmitter<string>()

    constructor(private userService: UserService, private modalService: NgbModal) {
        super()
        this.addSub(
            this.userService.studentClasses.subscribe((classes: any) => {
                this.classes = classes.slice()
            })
        )
        this.userService.loadStudentRosters()
    }

    public submitJoinClass($event, rosterCodeInput) {
        $event.preventDefault()
        if (rosterCodeInput.invalid) {
            return
        }
        this.joinCodeEntered.emit(rosterCodeInput.value)
    }

    public leaveClass($event, roster) {
        $event.preventDefault()
        const modal = this.modalService.open(LeaveRosterModalComponent)
        modal.componentInstance.roster = roster
        modal.componentInstance.classDetails = roster.teacher_name + "'s - " + roster.name
    }
}
